// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2JnSQ","controls":"styles_controls__3B9Tk","charLimit":"styles_charLimit__3v9Si","input":"styles_input__11uIf","send":"styles_send__3xvc1"};